import React, { useState } from "react";
import Menu from "../Menu/Menu";
import {
  AiOutlineInstagram,
  AiOutlineGithub,
  AiFillLinkedin,
} from "react-icons/ai";

import "./Navbar.scss";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <nav className="app__navbar">
      <p className="socials">
        <a href="https://www.instagram.com/horuschild" target="_blank">
          <AiOutlineInstagram />
        </a>
        <a href="https://www.github.com/horuschild" target="_blank">
          <AiOutlineGithub />
        </a>
        <a
          href="https://www.linkedin.com/in/zahra-indica-fathsyah"
          target="_blank"
        >
          <AiFillLinkedin />
        </a>
      </p>
      <Menu />
    </nav>
  );
};

export default Navbar;
